import type { TFunction } from 'i18next';
import { parseDirectReportsId } from '../buildTeamNodes';
import type { AdHocGroupConfig } from '../filtering';
import type { NewReportData } from '../types';

/** Human-readable rule descriptions, not membership/metric calculations. */
export function answerGroupFilterLabels(config: AdHocGroupConfig, data: NewReportData | null, t: TFunction): string[] {
  const labels: string[] = [];
  if (config.teamIds?.size) {
    const teams = [...config.teamIds].map((id) => {
      const directId = parseDirectReportsId(id);
      const team = data?.teams.find((item) => String(item.id) === (directId ?? id));
      const name = team?.teamName || t('tableTest.unnamedTeam');
      return directId ? t('tableTest.directTeamRule', { team: name }) : name;
    });
    labels.push(t('tableTest.teamRule', { teams: teams.join(', ') }));
  }
  const questions = new Map<string, { label: string; options: string[] }>();
  for (const selection of config.answerSelections) {
    const question = data?.questions.find((item) => item.index === selection.questionId);
    const questionLabel = question?.text ?? selection.questionId;
    const option = question?.answersLocal?.[Number(selection.optionId)] ?? selection.optionId;
    const statement =
      selection.statementId === undefined ? undefined : question?.statementsLocal?.[Number(selection.statementId)];
    const entry = questions.get(selection.questionId) ?? { label: questionLabel, options: [] };
    entry.options.push(statement ? `${statement}: ${option}` : option);
    // Question ids, not labels, keep identical question texts distinct.
    questions.set(selection.questionId, entry);
  }
  for (const entry of questions.values()) {
    labels.push(`${entry.label}: ${[...new Set(entry.options)].join(t('tableTest.orSeparator'))}`);
  }
  return labels;
}
